import { render, staticRenderFns } from "./data_warn.vue?vue&type=template&id=33ddc046&scoped=true"
import script from "./data_warn.vue?vue&type=script&lang=js"
export * from "./data_warn.vue?vue&type=script&lang=js"
import style0 from "./data_warn.vue?vue&type=style&index=0&id=33ddc046&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ddc046",
  null
  
)

export default component.exports